export default function ChevronLeft({ className }: { className ?: string}) {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='25' viewBox='0 0 24 25' fill='none' className={className}>
        <path
          d='M14 19.5L7 12.5L14 5.5'
          stroke='currentColor'
          strokeWidth='1.5'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
      </svg>
    );
  }
  